import { useState } from 'react'
import i18n from 'translations/i18n'
import { format } from 'utils/date'
import {
  TAnnouncementAttachment,
  TAnnouncementRecipients,
} from 'apis/OrgManagement/announcementSegrigation/useAnnouncementSeg.type'
import { Badge } from '@jisr-hr/ds-beta'
import DSIcon from 'components/DSIcon'
import { Flex, Typography } from '@jisr-hr/ds'
import styles from '../../announcements/style.module.css'
import SingleAnnouncementModal from './singleAnnouncementModal'
import WidgetActionsButtons from './widgetActionsButtons'

interface AnnouncementWidgetProps {
  item: TAnnouncementRecipients
  ind: number
  refetch: () => void
  sideDrawer?: boolean
}

const stripHtml = (html: string): string =>
  html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/<style[^>]*>[\s\S]*?<\/style>/g, '')
    .replace(/<\/?\w+/g, '')

const AnnouncementWidget = ({ item, ind, refetch, sideDrawer }: AnnouncementWidgetProps) => {
  const [showWidgetModal, setShowWidgetModal] = useState(false)

  const badge = (() => {
    if (item?.announcement?.is_follow_up) {
      return { status: 'raspberry', title: 'label.follow-up' }
    } else if (item?.announcement?.priority_level !== 'normal') {
      return { status: 'orange', title: item?.announcement?.priority_level }
    }
    return { status: 'gray', title: item?.announcement?.priority_level }
  })()

  return (
    <>
      <Flex
        key={ind}
        flexCol
        className={styles.containerAnnouncement}
      >
        <div onClick={() => setShowWidgetModal(true)}>
          <Flex
            itemsCenter
            className={styles.colorOfIcon}
            style={{ gap: 12 }}
          >
            <DSIcon name="calendar" />
            <Typography
              text={format(item?.created_at, 'dd MMM, yyyy')}
              variant="caption"
              textColor="color/fg/light"
            />
          </Flex>
          <Flex justifyBetween>
            <Flex>
              <img
                src={item?.announcement?.icon_url}
                alt={item?.announcement?.title}
                width={20}
                height={20}
                className="m-1"
              />
              <Typography
                text={item?.announcement?.title}
                variant="body-new/semibold"
              />
            </Flex>

            <Flex style={{ gap: 12, alignItems: 'center' }}>
              {sideDrawer && item.is_read && (
                <Flex itemsCenter>
                  <DSIcon
                    name="check"
                    size="xs"
                  />
                  <Typography
                    text={i18n.t('title.read')}
                    variant="subtitle-2"
                    textColor="color/fg/lighter"
                  />
                </Flex>
              )}
              <Badge
                label={i18n.t(badge.title)}
                color={badge?.status as any}
                size="small"
              />
            </Flex>
          </Flex>
          <Typography
            text={stripHtml(item?.announcement?.body)}
            variant="subtitle-2"
            textColor="color/fg/light"
            className={styles.bodyText}
          />
          <Flex>
            {sideDrawer &&
              item?.announcement?.attachments?.map(
                (attachment: TAnnouncementAttachment, index: number) => (
                  <>
                    {attachment?.content_type === 'image/png' && (
                      <img
                        key={index}
                        className="h-[87px] w-[117px] border-radius-[12px] object-contain "
                        src={attachment?.url}
                        alt={attachment.name}
                      />
                    )}
                  </>
                ),
              )}
          </Flex>
        </div>
        <WidgetActionsButtons
          item={item}
          refetch={refetch}
          sideDrawer={sideDrawer}
        />
      </Flex>

      <SingleAnnouncementModal
        announcementId={item.id}
        isOpen={showWidgetModal}
        onClose={() => setShowWidgetModal(false)}
      />
    </>
  )
}
export default AnnouncementWidget
